export default "__VITE_ASSET__Ctm5gJwM__"